/* eslint-disable */
import React from "react";
// @material-ui/core components
import {withStyles} from "@material-ui/core/styles";
// @material-ui/icons
import DashboardIcon from '@material-ui/icons/Dashboard';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";

import blogPostPageStyle from "assets/jss/material-kit-pro-react/views/blogPostPageStyle.js";


import BaseHeader from "./BaseView/BaseHeader";
import BaseFooter from "./BaseView/BaseFooter";
import Parallax from "../components/Parallax/Parallax";
import {getSeriesInfo, getSeriesInfoList, getSeriesLCStatus} from "../utils/request";
import SeriesInfoItem from "./components/SeriesInfoItem";
import EmptyCard from "./components/EmptyCard";
import storage from "../utils/storage";
import LoadingCard from "./components/LoadingCard";
import intl from "react-intl-universal";


function isEmpty(object) {
	if (object === null || object === undefined) {
		return true;
	}

	return false;
}

class SeriesInfo extends React.Component {


	constructor(props, context) {
		super(props, context);

		const id = this.props.match.params.id;
		this.state = {
			seriesId: id,
			seriesName: '',
			imageUrl: '',
			seriesInfo: '',
			videoList: [],
			videoReadyShow: [],
			videoLearnShow: [],

		};

		this.initData(id)
	}

	initData = (id) => {
		getSeriesInfo(id).then(res => {
			if (isEmpty(res.data) || res.data.length <= 0) {
				this.props.history.push('/series')
			} else {
				this.setState({
					seriesName: res.data.seriesName,
					imageUrl: res.data.imageUrl,
					seriesInfo: res.data.seriesInfo
				});

				document.title = this.state.seriesName + " - RobinAlgo";
			}
		});

		getSeriesInfoList(id).then(res => {
			this.setState({
				videoList: res.data,
			}, () => {
				if (!isEmpty(storage.get('token'))) {
					getSeriesLCStatus(this.state.seriesId).then(res => {
						const tagList = res.data;
						const learns = [];
						const collects = [];
						tagList.forEach((ele, index) => {
							// console.log(index + " " + JSON.stringify(ele))
							if (ele.lctype === 'learn') {
								learns.push(ele.id)
							}

							// if (ele.lctype === 'collect') {
							// 	collects.push(ele.id)
							// }
						});


						this.setState({
								videoLearn: learns,
								videoCollect: collects,
							}, () => {
								const _showReady = [];
								const _showLearn = [];

								this.state.videoList.forEach((ele, index) => {
									if (this.state.videoLearn.indexOf(ele.id) <= -1) {
										_showReady.push(ele)
									}
								});
								if (_showReady.length > 0) {
									this.setState({
										videoReadyShow: _showReady,
									});
								}
								this.state.videoList.forEach((ele, index) => {
									if (this.state.videoLearn.indexOf(ele.id) > -1) {
										_showLearn.push(ele)
									}
								});

								if (_showLearn.length > 0) {
									this.setState({
										videoLearnShow: _showLearn,
									});
								}
							}
						)
					})
				} else {
					this.setState({
						videoReadyShow: this.state.videoList
					})
				}
			})
		});


	};

	render() {
		const {classes} = this.props;

		const tagAll = this.state.videoList.map(data => {
			return <SeriesInfoItem
				// callback={this.callback.bind(this)}
				data={data}
			/>
		});
		const tagLearn = this.state.videoLearnShow.map(data => {
			return <SeriesInfoItem
				// callback={this.callback.bind(this)}
				data={data}
			/>
		});
		const tagReady = this.state.videoReadyShow.map(data => {
			return <SeriesInfoItem
				// callback={this.callback.bind(this)}
				data={data}
			/>
		});

		return (
			<div>
				<BaseHeader fixed/>

				<Parallax image={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/series_bg.jpg"}
						  filter="dark" small>
					<div className={classes.container}>
						<GridContainer justify="center">
							<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
								<h1 className={classes.title} style={{color: "white"}}>
									{this.state.seriesName}
								</h1>
							</GridItem>
							{/*<GridContainer xs={12} sm={12} md={8} className={classes.textCenter}>*/}
							{/*<GridItem xs={12} sm={12} md={6} className={classes.textCenter}>*/}
							{/*	<img src={this.state.imageUrl}*/}
							{/*		 style={{width: '100%'}}*/}
							{/*		 alt="..."/>*/}
							{/*</GridItem>*/}
							<GridItem xs={12} sm={12} md={6} className={classes.textCenter}>
								<h4 className={classes.title} style={{color: "#fff"}}>
									{this.state.seriesInfo}
								</h4>
							</GridItem>

							{/*</GridContainer>*/}
						</GridContainer>
					</div>
				</Parallax>
				<div className={classes.main}
					 style={{
						 backgroundColor: '#303030',
						 paddingTop: '32px'
					 }}>
					<div className={classes.container}>
						{
							this.state.videoList.length > 0 ?
								<NavPills
									alignCenter
									color="rose"
									active={1}
									tabs={[
										{
											tabButton: intl.get('all'),
											tabIcon: DashboardIcon,
											tabContent: (
												<GridContainer>
													{tagAll}
												</GridContainer>
											)
										},
										{
											tabButton: intl.get('wait_learn'),
											tabIcon: ScheduleIcon,
											tabContent: (
												<span>
														{
															tagReady.length > 0 ?
																<GridContainer>
																	{tagReady}
																</GridContainer>
																:
																<EmptyCard type={"series_ready"}/>
														}
													</span>
											)
										},
										{
											tabButton: intl.get('finish_learn'),
											tabIcon: ThumbUpAltIcon,
											tabContent: (
												<span>
														{
															tagLearn.length > 0 ?
																<GridContainer>
																	{tagLearn}
																</GridContainer>
																:
																<EmptyCard type={"series_learn"}/>
														}
											</span>
											)
										},
									]}
								/>
								:
								<LoadingCard/>
						}
					</div>
				</div>
				<BaseFooter/>
			</div>

		);
	}
}

export default withStyles(blogPostPageStyle)(SeriesInfo)
